{
	"temp": {
		"100": "#313b4a",
		"200": "#47465a",
		"300": "#5e636a",
		"700": "#785c5a",
		"800": "#714743",
		"900": "#6a322b"	
	},
	"bg": {
		"000": "#FDFCFA",
		"100": "#FAf9F5",
		"200": "#f5f4ed",
		"300": "#f0eee6",
		"400": "#DFDCD1",
		"500": "#C9C0A1",
		"600": "#B4AA86",
		"700": "#9F936B",
		"800": "#8A7C51",
		"900": "#746637"
	},
	"text": {
		"000": "#0e0e0d",
		"100": "#1A1918",
		"200": "#3C392A",
		"300": "#535146",
		"400": "#646257",
		"500": "#737063",
		"600": "#858577",
		"700": "#96978B",
		"800": "#A8A99E",
		"900": "#bcbcb3"
	},
	"accent-main": {
		"000": "#aa5234",
		"100": "#ba5a37",
		"200": "#c96342",
		"300": "#d8714f",
		"400": "#e7825f",
		"500": "#f39374",
		"600": "#f7a588",
		"700": "#f8b39e",
		"800": "#f0cbc3",
		"900": "#f2e0da"
	},
	"accent-secondary": {
		"000": "#1b6bbb",
		"100": "#207edd",
		"200": "#3f91e3",
		"300": "#5fa3e7",
		"400": "#7fb6ec",
		"500": "#9fc8f1",
		"600": "#bfdaf5",
		"700": "#cfe3f8",
		"800": "#d9e9f9",
		"900": "#e2edf9"
	},
	"oncolor": {
		"000": "#ffffff",
		"100": "#ffffff",
		"200": "#f8f8f7",
		"300": "#f8f8f7",
		"400": "#f0f0f0",
		"500": "#e8e8e8",
		"600": "#e0e0e0",
		"700": "#d8d8d8",
		"800": "#d0d0d0",
		"900": "#c8c8c8" 
	},
	"border": {
		"000": "#807c6a",
		"100": "#706b57",
		"200": "#706b57",
		"300": "#706b57",
		"400": "#706b57",
		"500": "#6b6b5a",
		"600": "#666656",
		"700": "#616152",
		"800": "#5c5c4d",
		"900": "#575748"
	},
	"danger": {
		"000": "#7c1b12",
		"100": "#a72419",
		"200": "#c8675e",
		"300": "#db8075",
		"400": "#e8998e",
		"500": "#eeb1a7",
		"600": "#f3c9c0",
		"700": "#f7d8d2",
		"800": "#fae7e4",
		"900": "#eed7d7"
	},
	"accent-pro": {
		"000": "#423771",
		"100": "#5545a1",
		"200": "#9c8ce3",
		"300": "#b2a3ed",
		"400": "#c8bbf4",
		"500": "#d4c7f7",
		"600": "#e0d3fa",
		"700": "#e5dcfc",
		"800": "#ebe5fe",
		"900": "#e6e3f1"
	},
	"bg-d": {
		"000": "#3D3D3A",
		"100": "#2E2E2B",
		"200": "#2B2A27",
		"300": "#21201C",
		"400": "#191814",
		"500": "#0F0F0D",
		"600": "#0A0A09",
		"700": "#060605",
		"800": "#030302",
		"900": "#010101"
	},
	"text-d": {
		"000": "#F8F8F7",
		"100": "#F4F3EE",
		"200": "#E4E4E1",
		"300": "#CDCBC4",
		"400": "#B7B4A8",
		"500": "#A6A39A",
		"600": "#8E8C84",
		"700": "#7C7B6F",
		"800": "#6A6961",
		"900": "#585754"
	},
	"accent-main-d": {
		"000": "#b6603c",
		"100": "#ad552f",
		"200": "#a3502a",
		"300": "#91452a",
		"400": "#7f3c26",
		"500": "#6e3321",
		"600": "#5d2a1c",
		"700": "#4c2217",
		"800": "#3b1a12",
		"900": "#40251a"
	},
	"accent-secondary-d": {
		"000": "#3f91e3",
		"100": "#207edd",
		"200": "#1b6bbb",
		"300": "#16589b",
		"400": "#12477c",
		"500": "#0e3861",
		"600": "#0b2947",
		"700": "#071c30",
		"800": "#04101c",
		"900": "#1e2630"
	},
	"border-d": {
		"000": "#7c7a71",
		"100": "#6b6960",
		"200": "#6c6a5f",
		"300": "#6c6a5f",
		"400": "#6c6a5f",
		"500": "#656258",
		"600": "#5e5c53",
		"700": "#56554d",
		"800": "#4f4d48",
		"900": "#474641"
	},
	"danger-d": {
		"000": "#e99189",
		"100": "#ef8379",
		"200": "#af3f35",
		"300": "#9c372e",
		"400": "#883029",
		"500": "#742924",
		"600": "#60211f",
		"700": "#4c1a1a",
		"800": "#381414",
		"900": "#362323"
	},
	"accent-pro-d": {
		"000": "#9b86f4",
		"100": "#6c5ab9",
		"200": "#5545a1",
		"300": "#4b3d92",
		"400": "#413684",
		"500": "#373075",
		"600": "#2d2966",
		"700": "#242257",
		"800": "#1b1b48",
		"900": "#29243d"
	},
	"brand": {
		"primary": "#D97757",
		"bg-logo": "#D87453",
		"text-logo": "#DA7858"
	},
	"heat": {
		"sellers-900": "#B44B42",
		"sellers-600": "#CD7D75",
		"sellers-300": "#D99186",
		"neutral-400": "#f0eee6",
		"buyers-300": "#6AA6E8",
		"buyers-600": "#5298E4",
		"buyers-900": "#4F89C8"
	},
	"growth": {
		"positive": "#009966",
		"negative": "#A8A99E" 
	}

}